import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {commonMusicLink} from "../_constants/api.constant";
export async function updateSongSequence(userId,postData){
    const response=await axios.put(
        commonMusicLink.SETSONGSEQUENCE,
       postData,
        {
            params:{
                userId:userId
            },
            headers:{
                Authorization: 'Token '+getSelfToken(),
            },
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
     

        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}